import React from 'react';
import { render } from 'react-dom';
import $ from 'jquery';
import ModuleGdprCookieSettingsContainer from './module-gdpr-cookie-settings-container';

let MountModuleGdprCookieSettings = {
  module(root) {
    if (!root) return;
    let props = JSON.parse($(root).attr('data-payload'));

    // Disable tabindex
    setTimeout(() => {
      $("*[tabindex]:not([tabindex='-1']), input:not([tabindex='-1']), a:not([tabindex='-1']), button:not([tabindex='-1']), select:not([tabindex='-1'])").each(function () {
        $(this).attr('tabindex', '-2');
      });

      // Enable tabindex for this module
      $(".gdpr_cookie_settings_accept_cookies button, .gdpr_cookie_settings_cookie_settings button, .gdpr_cookie_settings_cookie_settings .component-toggle-button").each(function () {
        $(this).attr('tabindex', '0');
      });
    }, 2000);

    return render(<ModuleGdprCookieSettingsContainer {...props} />, root);
  },

  init() {
    // Dont show cookie-settings if url contains ?print=true (print friendly version of a page)
    if (window.location.href.includes('?print=true')) {
      return;
    }

    // Lazyload styles, if not set this can cause defects in browsers such as Firefox
    // due to the current code logic combined with component-lightbox.
    import(/* webpackPreload: true *//* webpackChunkName: "stylesheets/component/lightbox" */ './../../components/component-lightbox/scss/_imports.scss')
      .then(() => {
        $('[data-module-gdpr-cookie-settings]').each((i, elm) => {
          this.module(elm);
        });
      });
  }
}

export default MountModuleGdprCookieSettings;
